export default __webpack_public_path__ + "static/media/ic_starInRound.9d3a8f69.svg";